import { render, staticRenderFns } from "./CarContacts.vue?vue&type=template&id=3bd40f2c&scoped=true&"
import script from "./CarContacts.vue?vue&type=script&lang=ts&"
export * from "./CarContacts.vue?vue&type=script&lang=ts&"
import style0 from "./CarContacts.vue?vue&type=style&index=0&id=3bd40f2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd40f2c",
  null
  
)

export default component.exports